import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import io, { Socket } from 'socket.io-client';
import { ToastContainer } from 'react-toastify';
import { useMount } from 'react-use';

import { setSocket } from 'store/notifications/reducer';
import { useAppSelector } from 'hooks';

const Notifications = () => {
  const dispatch = useDispatch();
  const socket = useAppSelector(({ notifications }) => notifications.socket) as Socket;
  const user = useAppSelector((state) => state.oauth.data);

  const createSocket = () => {
    const socketOpts = {
      auth: {
        token: user?.access_token || ''
      },
      path: '/socket.io',
      reconnectionAttempts: 3,
      reconnectionDelay: 15000,
      reconnectionDelayMax: 40000
    };
    const newSocket = io(`${import.meta.env.VITE_CLINICIAN_WEBSOCKET_URL}/alerts`, socketOpts);
    newSocket.on('connect', () => {
      /* eslint-disable no-console */
      console.log('socket.io connected');
      dispatch(setSocket(newSocket));
    });
  };

  socket &&
    socket.on('connect_error', () => {
      /* eslint-disable no-console */
      console.error('Connection lost to websocket. Will try to reconnect after a refresh.');
      socket.disconnect();
    });

  useMount(async () => {
    if (!socket?.connected) {
      createSocket();
    }
  });

  useEffect(() => {
    socket?.connected && socket.emit('joinRoom', user?.aid);
  }, [socket, user?.aid]);

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default Notifications;
